import { createContext } from "react";

export const CalculatorContext = createContext({});